module ARAndCashFlow

open Client
open Fable.React
open Fable.React.Props
open PortalLibs.Client.Util
open Fulma
open Model

let accountsReceivableView contract arBucketsOpt =
  div [ Style [
          MaxWidth "900px"
          MarginLeft "auto"
          MarginRight "auto"
          Display DisplayOptions.Flex
          FlexDirection "column"
        ] ] [
    Heading.h5 [] [
      str "Accounts Receivable"
    ]
    div [ Style [
            Display DisplayOptions.Flex
            FlexWrap "wrap"
            MaxWidth "870px"
            ] ] [
      textFieldReadOnly
        "Total Due"
        (contract.ARTotalDue
         |> DisplayNumber.AsCurrency.std)
      textFieldReadOnly
        "Unbilled"
        (contract.ARUnbilled
         |> DisplayNumber.AsCurrency.std)
      match arBucketsOpt with
      | None -> textFieldReadOnly "AR Buckets" "Loading..."
      | Some buckets ->
        yield!
          buckets
          |> List.map
               (fun bucket ->
                 textFieldReadOnly
                   bucket.Label
                   (bucket.Value
                    |> DisplayNumber.AsCurrency.std))
      textFieldReadOnly
        "Retainage"
        (contract.ARRetainage
         |> DisplayNumber.AsCurrency.std)
    ]
  ]

let cashFlowView contract =
  let asCurrency (x: float) = x |> DisplayNumber.AsCurrency.std
  div [ Style [
          MarginTop "10px"
          MaxWidth "900px"
          MarginLeft "auto"
          MarginRight "auto"
          Display DisplayOptions.Flex
          FlexDirection "column"
        ] ] [
    Heading.h5 [] [ str "Cash Flow" ]
    div [ Style [
            Display DisplayOptions.Flex
            FlexFlow "row wrap"] ] [
      textFieldReadOnly "Contract Amount" (contract.CFContractAmount |> asCurrency)
      textFieldReadOnly "Billings To Date" (contract.CFBillingsToDate |> asCurrency)
      textFieldReadOnly "Cost To Date" (contract.CFCostToDate |> asCurrency)
      textFieldReadOnlyStyles
        (Some 200)
        [ if contract.CFNetCashFlow < 0.0 then
            yield Feliz.style.color "red"
            yield Feliz.style.custom ("WebkitTextFillColor", "red") ]
        "Net Cash Flow" (contract.CFNetCashFlow |> asCurrency)
    ]
    div [ Style [
            Display DisplayOptions.Flex
            FlexFlow "row wrap" ] ] [
      textFieldReadOnly "Estimated Cost" (contract.CFEstimatedCost|> asCurrency)
      textFieldReadOnly "Contract Receivables & Retainage" (contract.CFCRAndRetainage|> asCurrency)
      textFieldReadOnly "Accounts Payable" (contract.CFAccountsPayable|> asCurrency)
    ]
    div [ Style [
            Display DisplayOptions.Flex
            FlexFlow "row wrap" ] ] [
      textFieldReadOnly "Estimated Gross Profit" (contract.CFEstimatedGrossProfit|> asCurrency)
      textFieldReadOnly "Cash Collected" (contract.CFCashCollected|> asCurrency)
      textFieldReadOnly "Cash Paid" (contract.CFCashPaid|> asCurrency)
    ]
  ]

let View (model: ContractPageModel.Model) contract =
  div [ Style [ PaddingBottom "50px" ] ] [
    accountsReceivableView contract (model.ContractARBuckets |> Map.tryFind contract.Id)
    cashFlowView contract
  ]